import { render } from "./AdvancedClassLessonAccesses.vue?vue&type=template&id=d9d80ac8"
import script from "./AdvancedClassLessonAccesses.vue?vue&type=script&lang=js"
export * from "./AdvancedClassLessonAccesses.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__